import store from './store'
import KeplerSDK from './keplerSdk'

const MaggieHelper = {
  callback: null,
  notification: function (title, subtitile, severity, code = null) {
    store.dispatch('newNotification', {
      title: title,
      subtitle: subtitile,
      style: severity,
      code: code
    })
  },
  login: function (user, token) {
    store.dispatch('login', user)
    if (token != null) {
      this.token(token)
    }
  },

  token: function (token) {
    store.dispatch('setToken', token)
    //app.$http.headers.put['Authorization'] = 'Bearer '+token
  },
  checkForToken: function () {
    var that = this
    if (localStorage.getItem('token') != null) {
      var token = localStorage.getItem('token')
      this.token(token)
      KeplerSDK.driver(function (driver) {
        that.login(driver)
      }, function (e) {
        localStorage.removeItem('token')
      })
    }
  },

  isAdminLoggedIn() {
    return localStorage.getItem('backoffice-token') !== null
  },
  registerCallback: function (incomingCallback) {
    this.callback = incomingCallback
  },
  openRightPanel: function (options) {
    options.position = 'right'
    this.callback(options)
  },
  openTopPanel: function (options) {
    options.position = 'top'
    this.callback(options)
  },
  closeTopPanel: function () {
    this.callback({})
  },
  closeRightPanel: function () {
    $('#offCanvasRight').foundation('close')
  },

  showPreloader() {
    $('#preloader').removeClass('is-hidden')
  },
  hidePreloader() {
    $('#preloader').addClass('is-hidden')
  },
}

export default MaggieHelper



// WEBPACK FOOTER //
// ./src/maggieHelper.js